import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ShieldAlertIcon, AlertTriangleIcon, ScaleIcon, HardHatIcon, CrosshairIcon, BookOpenIcon, MapPinIcon, ShieldCheckIcon, BeerIcon, PhoneIcon, FileTextIcon, HeartIcon } from 'lucide-react';
const menuItems = [{
  path: '/what-to-say-to-cops',
  icon: ShieldAlertIcon,
  label: 'What to Say to Cops',
  color: '#dc2626',
  urgent: true
}, {
  path: '/tips-after-crash',
  icon: AlertTriangleIcon,
  label: 'Tips After a Crash',
  color: '#f97316',
  urgent: true
}, {
  path: '/horrible-laws',
  icon: ScaleIcon,
  label: '4 Horrible MI Laws',
  color: '#d4a853'
}, {
  path: '/helmet-law',
  icon: HardHatIcon,
  label: 'MI Helmet Law',
  color: '#d4a853'
}, {
  path: '/gun-laws',
  icon: CrosshairIcon,
  label: 'MI Gun Laws',
  color: '#d4a853'
}, {
  path: '/motorcycle-laws',
  icon: BookOpenIcon,
  label: 'MI Motorcycle Laws',
  color: '#d4a853'
}, {
  path: '/best-rides',
  icon: MapPinIcon,
  label: '5 Best MI Rides',
  color: '#22c55e'
}, {
  path: '/insurance',
  icon: ShieldCheckIcon,
  label: 'Recommended Insurance',
  color: '#3b82f6'
}, {
  path: '/biker-bars',
  icon: BeerIcon,
  label: 'Great MI Biker Bars',
  color: '#a855f7'
}, {
  path: '/contact',
  icon: PhoneIcon,
  label: 'Contact Us',
  color: '#d4a853'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.06
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function HomePage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-[#0a0a0a] safe-bottom" data-id="element-224">
      {/* Header */}
      <header className="px-5 pt-[env(safe-area-inset-top)] pb-2" data-id="element-225">
        <div className="pt-6 pb-4" data-id="element-226">
          <div className="flex items-center gap-3 mb-4" data-id="element-227">
            <div className="w-12 h-12 rounded-full bg-[#1a1a1a] border-2 border-[#d4a853] flex items-center justify-center overflow-hidden" data-id="element-228">
              <span className="text-2xl" data-id="element-229">⚖️</span>
            </div>
            <div data-id="element-230">
              <h1 className="text-xl font-bold text-white" data-id="element-231">
                The Motorcycle Lawyer
              </h1>
              <p className="text-xs text-[#a3a3a3]" data-id="element-232">Michigan Legal Resource</p>
            </div>
          </div>

          {/* Emergency Banner */}
          <motion.button onClick={() => navigate('/contact')} className="w-full bg-gradient-to-r from-[#dc2626] to-[#b91c1c] rounded-2xl p-4 flex items-center gap-4" whileTap={{
          scale: 0.98
        }} data-id="element-233">
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center" data-id="element-234">
              <PhoneIcon className="w-6 h-6 text-white" data-id="element-235" />
            </div>
            <div className="flex-1 text-left" data-id="element-236">
              <p className="text-white font-bold" data-id="element-237">Been in an accident?</p>
              <p className="text-white/80 text-sm" data-id="element-238">
                Get free legal consultation now
              </p>
            </div>
            <div className="text-white/60" data-id="element-239">→</div>
          </motion.button>
        </div>
      </header>

      {/* Menu Grid */}
      <main className="px-5 pb-8" data-id="element-240">
        <motion.div className="grid grid-cols-2 gap-3" variants={container} initial="hidden" animate="show" data-id="element-241">
          {menuItems.map(menuItem => {
          const Icon = menuItem.icon;
          return <motion.button key={menuItem.path} variants={item} onClick={() => navigate(menuItem.path)} className={`bg-[#1a1a1a] border ${menuItem.urgent ? 'border-[#dc2626]/30' : 'border-[#2a2a2a]'} rounded-2xl p-4 text-left active:bg-[#252525] transition-colors`} whileTap={{
            scale: 0.97
          }} data-id="element-242">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-3" style={{
              backgroundColor: `${menuItem.color}15`
            }} data-id="element-243">
                  <Icon className="w-5 h-5" style={{
                color: menuItem.color
              }} data-id="element-244" />
                </div>
                <p className="text-sm font-medium text-white leading-tight" data-id="element-245">
                  {menuItem.label}
                </p>
              </motion.button>;
        })}
        </motion.div>

        {/* Credentials */}
        <motion.div className="mt-6 bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} data-id="element-246">
          <div className="flex items-center gap-4" data-id="element-247">
            <div className="w-16 h-16 rounded-xl bg-[#252525] flex items-center justify-center" data-id="element-248">
              <span className="text-3xl" data-id="element-249">🏆</span>
            </div>
            <div data-id="element-250">
              <p className="text-[#d4a853] font-semibold text-sm" data-id="element-251">
                Best Law Firms
              </p>
              <p className="text-white font-bold" data-id="element-252">U.S. News & World Report</p>
              <p className="text-[#a3a3a3] text-xs" data-id="element-253">
                Best Lawyers® Recognition
              </p>
            </div>
          </div>
        </motion.div>
      </main>
    </div>;
}